'use client';

import z from 'zod';
import { PortableText, PortableTextReactComponents } from '@portabletext/react';
import { simpleBlockContent } from '@stereoagency/sanity-schema';
import LinkAnnotationComponent from './LinkAnnotationComponent.client';

interface Props {
  value: z.infer<typeof simpleBlockContent.validator>;
  components?: Partial<PortableTextReactComponents>;
}

export default function SimpleBlockContent({ value, components }: Props) {
  return (
    <PortableText
      value={value}
      components={{
        ...components,
        marks: {
          link: LinkAnnotationComponent,
          ...components?.marks
        }
      }}
    />
  );
}
